import { Dialog, DialogProps, Typography } from '@mui/material';
import { GridColType } from '@mui/x-data-grid';
import FormBlock from 'components/form/FormBlock';
import { JSONSchema7 } from 'json-schema';

export type NewColumn = {
  name: string;
  type: GridColType;
};

const formSchema: JSONSchema7 = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      title: 'Column Name',
    },
    type: {
      type: 'string',
      enum: ['string', 'number', 'boolean'],
      title: 'Column Type',
      default: 'string',
    },
  },
  required: ['name', 'type'],
};

type AddColumnDialogProps = DialogProps & {
  onSubmit: (data: NewColumn) => void;
  onClose: () => void;
};

export const AddColumnDialog = ({ open, onClose, onSubmit }: AddColumnDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="flex gap-2 flex-col m-10">
        <Typography variant="h5">Add new column</Typography>
        <div className="w-full">
          <FormBlock onSubmit={onSubmit} onCancel={onClose} schema={formSchema} formId="ADD_COLUMN"></FormBlock>
        </div>
      </div>
    </Dialog>
  );
};
